<template>
  <div>
    <div v-bind:class="!record.active ? 'close': ''">
      <div class="record-head pointer" @click="openLevelDialog(record.id)">
        <div class="record-left">
          <span>
           <v-icon color="#4dbac0" size="18">calendar_view_day</v-icon>
            <b class="text-green ml-1">Deleted Zone</b>
          </span>
          <span class="text-grey">
            |
            <span @click="emitUser(record.user.username)" class="user-name">{{record.user.username}}</span>
            |
            {{openTime}}

          </span>
          <div class="record-body">
            <div style="width: 100%; border-bottom: 1px solid white;position:relative;top:12px"></div>
            <div>
              <span v-if="record.data.name != ''">
              <b>{{record.data.name}} </b>
              |
              </span>
              <b>{{record.data.ticker.user}}</b>
              | Level:
              <b>{{record.data.price}} </b>
              <v-icon v-if="record.data.type == 'Long' " color="#79C04D">trending_up</v-icon>
              <v-icon v-if="record.data.type == 'Short' " color="#E62163">trending_down</v-icon>
              <v-icon v-if="record.data.type == 'Neutral' " color="#808F9C">trending_flat</v-icon>

            </div>
          </div>
        </div>
      </div>
      <div class="record-right">
        <span  @click="routeUser()" class="pointer hover">
        <Avatar
          v-if="record.user.avatar != null"
          class="timeline-avatar"
          :src="`https://tradeinpool.com/upload/${record.user.avatar}.png`"
          :size="40"
        ></Avatar>
        <Avatar v-else class="timeline-avatar" :username="record.user.username" :size="40"></Avatar>
        </span>
        <div class="record-menu">
          <MenuCard :record="record" /> 
        </div>
      </div>
    </div>
    <ZoneDialog :id="levelDetailId" @clearDetail="clearDetail"/>
  </div>
</template>

<script>
import ZoneDialog from "@/components/zoneDialog";
import Avatar from "vue-avatar";
import MenuCard from "@/components/menuCard";
var moment = require("moment-timezone");
export default {
  components: {
    Avatar,
    MenuCard,
    ZoneDialog
  },
  props: ["record"],
  data() {
    return {
      levelDetailId: null,
      setOpacity: "open",
      type: "",
      symbol: "",
      mainClass: "",
      fromNow: moment
        .tz(this.record.created, this.$store.getters.timezone)
        .fromNow(),
      remain: null //=> '26 years, 9 months, and 4 days'
    };
  },
  methods: {
    openLevelDialog(id){
      this.levelDetailId = id
    },
    clearDetail(){
      this.levelDetailId = null 
    },
    emitUser(user){
      this.$emit("emitUser",user)
    },
    routeUser() {
      return this.$router.push({path: "/user/"+this.record.user.username});
    },
    replyName(val) {
      this.$emit("reply_to", val);
    },
    updateTimes() {

    
    }
  },
  filters: {},
  mounted() {
    // updating record time
    this.updateTimes();
    setInterval(() => {
      this.updateTimes();
    }, 1000);
  },

  computed: {
    openTime() {
      var value = this.record.created;
      var a = moment.tz(value, this.$store.getters.timezone).startOf('day');
      var b = moment.tz(new Date(), this.$store.getters.timezone).startOf('day');
      var diff = a.diff(b, "days"); // =1
      if (diff == 0)
        return  "Today | " + moment
          .tz(value, this.$store.getters.timezone)
          .format("HH:mm");
      else if (diff == -1)
        return  "Yesterday | " + moment
          .tz(value, this.$store.getters.timezone)
          .format("HH:mm");
      else
        return moment
          .tz(value, this.$store.getters.timezone)
          .format("YYYY-MM-DD | HH:mm");
    }
  }
};
</script>

<style scoped>
.sajz {
  font-size: 18px;
  margin-bottom: 3px;
  margin-right: 2px;
}

.down,
.errors {
  color: #e62163;
}

.up,
.successes {
  color: #79c04d;
}

.close {
  opacity: 0.4;
}

.hourglass_empty {
  color: #4dbac0;
}

.record-body {
  color: white;
  width: auto;
  margin-left: 22px;
}
</style>
